import apiClient from './apiClient';

/** One SYS_AuditLog row — matches backend/modules/auditlog.Entry JSON shape. */
export interface AuditLogEntry {
  id: number;
  occurred_at: string;
  user_id: string;
  session_id: string | null;
  ip: string | null;
  form_id: string;
  doc_key: string;
  action: string;
  field_changes: Record<string, { before?: unknown; after?: unknown }> | null;
  full_snapshot: Record<string, unknown> | null;
}

export interface AuditLogListResponse {
  data: AuditLogEntry[];
  total: number;
  page: number;
  pageSize: number;
}

export interface AuditLogFilter {
  user_id?: string;
  form_id?: string;
  doc_key?: string;
  action?: string;
  from?: string; // YYYY-MM-DD
  to?: string;   // YYYY-MM-DD
  page?: number;
  pageSize?: number;
}

/** 稽核記錄查詢 API — 唯讀，無新增/修改/刪除端點（SYS_AuditLog 為 append-only）。 */
export const auditLogApi = {
  async list(filter: AuditLogFilter): Promise<AuditLogListResponse> {
    const res = await apiClient.get('/api/audit-logs', { params: filter });
    return res.data as AuditLogListResponse;
  },
};
